import React, { Fragment } from 'react'
import { Breadcrumb, Card, Row } from 'antd'
import List from './List'
import CenterModal from './CenterModal'
import CentersApi from '../../../api/Corporates/Centers'
import { unflatten } from '../../../modules/Utils'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'

const api = new CentersApi()

function CentersCont() {
  const { fetching, fetch, list } = useFetchList(api.list, undefined, false, unflatten)
  const { checkFrom, object: center, formRef, modalType, visible, update, submitting, onCancel, onShow } = useModalData(
    undefined,
    api.update,
    undefined,
    fetch
  )

  return (
    <Centers
      {...{
        fetching,
        fetch,
        center,
        list,
        visible,
        checkFrom,
        formRef,
        update,
        submitting,
        onCancel,
        onShow,
        modalType,
      }}
    />
  )
}

function Centers(props) {
  return (
    <Fragment>
      <Card>
        <Row>
          <Breadcrumb>
            <Breadcrumb.Item href="#/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>Corporate</Breadcrumb.Item>
            <Breadcrumb.Item>Centers</Breadcrumb.Item>
          </Breadcrumb>
          <h2>Responsibility Centers</h2>
          <p>View and list Responsibility of Centers.</p>
        </Row>
      </Card>
      <Card style={{ margin: 10 }}>
        <CenterModal {...props} />
        <List {...props} />
      </Card>
    </Fragment>
  )
}

export default CentersCont
